export default class DialogValue
{
	remoteClass = "gongqi.erp.gotmodel.form.dialog.DialogValue";
	id;
	entityId;
	editorType;
	value;
}


// WEBPACK FOOTER //
// ./src/components/dialog/remote/DialogValue.js